import React from 'react';

import MUITab, { TabProps } from '@material-ui/core/Tab';

const Tab: React.FC<TabProps> = ({ children, ...rest }) => {
  return <MUITab label={children} {...rest} />;
};

export default Tab;
